import React from "react";
import { Helmet } from "react-helmet";
import '../../styles/lyrics.css';

const BlewUp = () => {
  return (
    <div>
      <Helmet>
        <title>LYRICS - BLEW UP</title>
      </Helmet>

      <section class="lyrics-catalog">
        <p style={{fontSize: '50px', color: '#ffffff', lineHeight: '90%', marginBottom: '60px'}}>LYRICS - BLEW UP</p>
        <div class="lyrics-frames">
            <div class="lyrics">
                [Chorus]<br/>Bust Down on your team with the motherfucking gang man I swear<br/>Bust Down on your team
                with the motherfucking gang man I swear<br/><br/>[Verse 1]<br/>Kehna jo kehde sab leta mai sehke mai tere
                se pehele kama chuka fame<br/>Mere jageh ko ye lene ko deke bathere baithe hue, jala dunga mai<br/>Bete
                mere bagair ye sab vele pade they akele hum faile on top the game and<br/>I'm patiently waiting for
                making a way never made a mistake bana GOD I became<br/>I'm a sick breed like a demogorgon<br/>You can
                miss me man I'm blasting off and all of<br/>This seems like a para of (awful) a little<br/>Mystery that I
                can't recall<br/>Aur mai to chutgaya deke istifaa<br/>Na jaane mera uthna baithna kiske saath<br/>Tu mere
                aage ghutne tekna iske baad<br/>Aur bacha abhi kuch samay ka intejaar<br/>I blew
                up<br/><br/>[Pre-Chorus]<br/>Bust Down on your team with the motherfucking gang man I swear<br/>Bust Down on
                your team with the motherfucking gang man I swear<br/>Bust Down on your team with the motherfucking gang
                man I swear<br/>Bust Down on your team with the motherfucking gang man I swear<br/><br/>[Chorus]<br/>Man I
                blew up<br/>Man I'm close to my dreams<br/>Khudpe naaz, rakh yakeen<br/>Man I'm popping the
                scene<br/>Sending shots to your team<br/>I should've<br/>Never taken advice<br/>I'm a GOD on the mic<br/>Bani
                chaudh, bani hype<br/>Dikha scars, dikha stripes<br/><br/>Man I blew up<br/>Man I'm close to my
                dreams<br/>Khudpe naaz, rakh yakeen<br/>Man I'm popping the scene<br/>Sending shots to your team<br/>I
                should've<br/>Never taken advice<br/>I'm a GOD on the mic<br/>Bani chaudh, bani hype<br/>Dikha scars, dikha
                stripes<br/><br/>[Verse 2]<br/>I Blew up<br/>Ye kare hate bohot mera hoonar<br/>Hai kara take-off, space
                shuttles<br/>Boy I can't stop, man couldn't<br/>Fake friends dikhe, lage fucked up<br/>Waqt bura kehrahe wo
                tough luck<br/>Pyara bohot, kehta tha much love<br/>Kabhi gusse me dekhe nai ab tak<br/>Gand fati, thas
                gayele ye log bohot<br/>Bache nai jyada fucks dene inlog ko<br/>You can't see me now with a fiend or
                foe<br/>Hu nai mai John, you ain't (Cena) seeing a ghost<br/>Checks - Coming<br/>Gang - Run It<br/>OH MY
                GAUSH, they don't want it<br/>I let 'em wake up in the morning<br/>Back to back hits<br/>Inhe drive karu
                crazy like an Aston Martin<br/>Meri najar hai har jageh jaise big boss cam recording<br/>Blast 'em off and
                I can't recall 'em<br/>Fuck them all and<br/>Fuck your morals<br/>Paisa de tu, fuck exposure<br/>I'm a GOD,
                no fucking mortal<br/>Fuck you are? Ye darke chupgaye<br/>Bhai launde hamare yaha seedhe gharpe
                ghustey<br/>Tu chup reh<br/><br/>
                [Chorus]<br/>Blew up<br/>Man I'm close to my dreams<br/>Khudpe naaz, rakh yakeen<br/>Man I'm popping the
                scene<br/>Sending shots to your team<br/>I should've<br/>Never taken advice<br/>I'm a GOD on the mic<br/>Bani
                chaudh, bani hype<br/>Dikha scars, dikha stripes<br/>Man I<br/>Blew up<br/><br/>Blew up<br/>Man I'm close to
                my dreams<br/>Khudpe naaz, rakh yakeen<br/>Man I'm popping the scene<br/>Sending shots to your team<br/>I
                should've<br/>Never taken advice<br/>I'm a GOD on the mic<br/>Bani chaudh, bani hype<br/>Dikha scars, dikha
                stripes<br/>Man I<br/>Blew up
            </div>
        </div>
    </section>
      

    </div>
  );
};

export default BlewUp;
